import React from "react";

const ModalOverlay = ({ children, className = "" }) => {
  return (
    <div className={`fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4 ${className}`}>
      {children}
    </div>
  );
};

export default ModalOverlay;
